import { render, staticRenderFns } from "./ImportSettings.vue?vue&type=template&id=1591db68&scoped=true&"
import script from "./ImportSettings.vue?vue&type=script&lang=js&"
export * from "./ImportSettings.vue?vue&type=script&lang=js&"
import style0 from "./ImportSettings.vue?vue&type=style&index=0&id=1591db68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1591db68",
  null
  
)

export default component.exports
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QFile,QIcon,QOptionGroup,QSelect,QCheckbox,QSeparator,QBtn});
